module.exports = __webpack_public_path__ + "static/media/atlantic-mackerel.bc9b0213.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/atlantic-mackerel.png
// module id = 296
// module chunks = 0